import enDashboard from './en';
import ruDashboard from './ru';

export default {
  en: {
    ...enDashboard,
  },
  ru: {
    ...ruDashboard,
  },
};
